// extracted by mini-css-extract-plugin
export default {"progressContainer":"styles_progressContainer__bFYfz","progressBar":"styles_progressBar__ErDtq"};